export const wrapIndex = (min: number, max: number, v: number): number => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

export const swipePower = (offset: number, absDistance: number): number => {
  return (offset / absDistance) * 100;
};
